import Storage from "../storage";
var LocalStorageAdapter = {
  namespace: "alephbet",
  set: function set(key, value) {
    return new Storage(this.namespace).set(key, value);
  },
  get: function get(key) {
    return new Storage(this.namespace).get(key);
  }
};
export default LocalStorageAdapter;